import React from "react";
import { _t } from "../../../../functions/Functions";

/**
 * Render a styled badge for complaint status.
 * Supports: closed, resolved, open, in_progress, rejected
 */
export const renderStatusBadge = (item, t = (s) => s, defaultStatus = "") => {
  const rawStatus = item?.status_label || item?.status || defaultStatus;
  if (!rawStatus || rawStatus === "-") return "-";

  const normalized = (typeof rawStatus === "string" ? rawStatus : "").trim().toLowerCase();

  let badgeClass = "badge-status-default";
  if (normalized === "closed") {
    badgeClass = "badge-status-closed";
  } else if (normalized === "resolved") {
    badgeClass = "badge-status-resolved";
  } else if (normalized === "open") {
    badgeClass = "badge-status-open";
  } else if (normalized === "in_progress" || normalized === "in progress") {
    badgeClass = "badge-status-in-progress";
  } else if (normalized === "rejected") {
    badgeClass = "badge-status-rejected";
  }

  return (
    <span className={`complaint-status-badge ${badgeClass}`}>
      <span className="complaint-badge-dot" />
      {_t(t(rawStatus))}
    </span>
  );
};

/**
 * Render a styled badge for complaint priority.
 * Supports: low, medium, high, critical
 */
export const renderPriorityBadge = (item, t = (s) => s) => {
  const rawPriority = item?.priority || item?.severity_label;
  if (!rawPriority || rawPriority === "-") return "-";

  const normalized = (typeof rawPriority === "string" ? rawPriority : "").trim().toLowerCase();

  let badgeClass = "badge-priority-default";
  if (normalized === "low") {
    badgeClass = "badge-priority-low";
  } else if (normalized === "medium") {
    badgeClass = "badge-priority-medium";
  } else if (normalized === "high") {
    badgeClass = "badge-priority-high";
  } else if (normalized === "critical") {
    badgeClass = "badge-priority-critical";
  }

  return (
    <span className={`complaint-priority-badge ${badgeClass}`}>
      <span className="complaint-badge-dot" />
      {_t(t(rawPriority))}
    </span>
  );
};
